import { Notify } from '@flexisaf/flexibull2/build/notify';
import { DEFAULT_ERROR_MESSAGE, ERROR, SUCCESS, TOP_RIGHT } from './constants';
import { StepsWithFixedPayment } from 'components/WorkflowSteps/utils';
import {
  clearAuthOrganisationId,
  getAdminStorageSlugCandidates,
  getAdminStorageWriteSlug,
} from './portalSlug';

const moment = require('moment-timezone');

const routeOrgSlug = () => window.location.pathname.split('/')[1] || '';

const storageKey = (slug, item) => `safapply_admin_app_${slug}_${item}`;

const getLocalItem = (item) => {
  const candidates = getAdminStorageSlugCandidates(routeOrgSlug());
  for (let i = 0; i < candidates.length; i += 1) {
    const value = localStorage.getItem(storageKey(candidates[i], item));
    if (value != null) {
      return value;
    }
  }
  return null;
};

const setLocalItem = (item, value) => {
  const slug = getAdminStorageWriteSlug(routeOrgSlug());
  return localStorage.setItem(storageKey(slug, item), value);
};

const clearLocalItem = (item) => {
  getAdminStorageSlugCandidates(routeOrgSlug()).forEach((slug) => {
    localStorage.removeItem(storageKey(slug, item));
  });
};

export const getOrgName = () => {
  const orgName = window.location.pathname.split('/')[1];
  return orgName;
}

export const getLocalAccessToken = () => getLocalItem('access_token');
export const getLocalRefreshToken = () => getLocalItem('refresh_token');
export const getLocalUser = () => getLocalItem('user');
export const getLocalUserNameAbbreviation = (user) =>
  `${user?.firstName[0]}${user?.lastName[0]}`.toUpperCase();
export const getLocalUserAdminDetails = (
  adminLevelItemId,
  adminLevelItems,
  adminLevels
) => {
  const adminLevelItem = adminLevelItems?.find(
    (item) => item?.id === adminLevelItemId
  );
  const adminLevel = adminLevels?.find(
    (level) => level?.id === adminLevelItem?.administrationLevel?.id
  );

  return {
    adminLevel,
    adminLevelItem,
  };
};

export const setLocalAccessToken = (value) =>
  setLocalItem('access_token', value);
export const setLocalRefreshToken = (value) =>
  setLocalItem('refresh_token', value);
export const setLocalUser = (value) => setLocalItem('user', value);

export const clearLocalAccessToken = () => clearLocalItem('access_token');
export const clearLocalRefreshToken = () => clearLocalItem('refresh_token');
export const clearLocalUser = () => clearLocalItem('user');

export const getParentId = (adminLevels, currentOrder) => {
  const t = adminLevels.filter((level) => {
    if (currentOrder === 1) {
      return true;
    }
    return level.levelOrder === currentOrder - 1;
  })[0];

  return t?.id;
};

export const logout = () => {
  clearLocalUser();
  clearLocalAccessToken();
  clearLocalRefreshToken();
  clearAuthOrganisationId();
  window.location.reload();
};

export const stringToHslColor = (text = '', s = 50, l = 80) => {
  const str = text.replace(' ', '');
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = Math.abs(hash) % 360;
  return `hsl(${h}, ${s}%, ${l}%)`;
};

export const calculateOffset = (page, pageSize) => {
  const offSet = (page - 1) * pageSize;
  return offSet;
};

/** FlexiSelect option value (supports legacy label.props.value shape). */
export const getSelectOptionValue = (option) =>
  option?.value ?? option?.label?.props?.value ?? null;

const STORE_PREFIX = 'SAFAPPLY_STORE';

export const typeGenerator = (typeName) => ({
  request: `${STORE_PREFIX}_${typeName}`,
  success: `${STORE_PREFIX}_${typeName}_SUCCESS`,
  failure: `${STORE_PREFIX}_${typeName}_FAILED`,
});

export const convertArrayToObject = (array, key) => {
  const initialValue = {};
  return array.reduce(
    (obj, item) => ({
      ...obj,
      [item[key]]: item,
    }),
    initialValue
  );
};

export const successNotifier = (message) => {
  Notify(message || DEFAULT_ERROR_MESSAGE, {
    position: TOP_RIGHT,
    status: SUCCESS,
  });
};

export const errorNotifier = (message) => {
  Notify(message || DEFAULT_ERROR_MESSAGE, {
    position: TOP_RIGHT,
    status: ERROR,
  });
};

export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
}

export function getStepsWithPaymentsFromWorkflow(steps) {
  if (!steps || steps?.length === 0) return;
  const stepsWithPayment = steps?.filter(
    (step) =>
      step.paymentMode === 'BEFORE' ||
      step.paymentMode === 'AFTER' ||
      step.type === StepsWithFixedPayment[0]
  );

  return stepsWithPayment;
}

export const downloadFile = (url, fileName) => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const calculateDateOffset = (d, t) => {
  const serverTime = new Date(d);
  const timeZone = t || moment.tz.guess();
  const tzoffset = moment().tz(timeZone).utcOffset();
  const atime =
    Math.sign(tzoffset) === -1
      ? new Date(
          serverTime.setMinutes(serverTime.getMinutes() - Math.abs(tzoffset))
        )
      : new Date(
          serverTime.setMinutes(serverTime.getMinutes() + Math.abs(tzoffset))
        );

  return atime;
};
